import { ApiClient } from './ApiClient';

export const login = (credentials) => ApiClient.post('/login-admin', credentials);
export const checkAuth = () => ApiClient.get('/check-auth-admin');
export const recoverPassword = (email) => ApiClient.post('/recover-password', email);
export const resetPassword = (credentials) => ApiClient.post('/reset-password', credentials);
export const changePassword = (payload) => ApiClient.put('/change-password', payload);
